var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CatBoostClassifierConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ProbabilityClassifierConfig } from './probabilityClassifierConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfigInfo } from './toolConfigInfo';
import { catBoostClassifierConfigSchemaValidation } from '../validations.generated';
export const catBoostClassifierConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:CatBoostClassifierConfig',
    type: 'object',
    properties: {},
    required: []
};
let CatBoostClassifierConfig = CatBoostClassifierConfig_1 = class CatBoostClassifierConfig extends ProbabilityClassifierConfig {
    constructor(labelColumn, threshold, excludeColumns, autoExclude, autoExcludeCorrMethod, autoExcludeCorrThreshold, autoExcludePpsThreshold, customFormats, performanceMeasureMethod) {
        super(ToolType.CAT_BOOST_CLASSIFIER, labelColumn, threshold, excludeColumns, autoExclude, autoExcludeCorrMethod, autoExcludeCorrThreshold, autoExcludePpsThreshold, customFormats, performanceMeasureMethod);
        JSON.validate(this, CatBoostClassifierConfig_1);
    }
    static get info() {
        return new ToolConfigInfo(ToolType.CAT_BOOST_CLASSIFIER.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.CLASSIFIER, ToolCategories.UNSEEN], this.ins, this.outs, ['classify', 'classifier'], false);
    }
};
CatBoostClassifierConfig = CatBoostClassifierConfig_1 = __decorate([
    JsonSchemaV2(catBoostClassifierConfigSchema, catBoostClassifierConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.CAT_BOOST_CLASSIFIER)
], CatBoostClassifierConfig);
export { CatBoostClassifierConfig };
//# sourceMappingURL=catBoostClassifierConfig.js.map